import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import TopUpsItemDto from '../models/dto/top-ups-item.dto';
import {
  cancelTopUp,
  createTopUps,
  getCreditsConsumption,
  getDetailsTopUps,
  getTopUps,
} from '../services';
import IPaginatedParams from '@models/paginated-params';
import ISearchCriteria from '@models/dto/searchCriteria.dto';

export const useCreateTopUps = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (newTopUps: TopUpsItemDto) => {
      return await createTopUps(newTopUps);
    },
    onSuccess: () => queryClient.invalidateQueries(['topUps']),
  });
};

export const useGetTopUps = (
  paginatedParams: IPaginatedParams,
  searchCriteria: ISearchCriteria,
) => {
  return useQuery({
    queryKey: ['topUps', paginatedParams, searchCriteria],
    queryFn: () => getTopUps(paginatedParams, searchCriteria),
  });
};

export const useCancelTopUp = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (topUpId: string) => {
      return await cancelTopUp(topUpId);
    },
    onSuccess: () => queryClient.invalidateQueries(['topUps']),
  });
};

export const useGetDetailsTopUp = (topUpId: string) => {
  return useQuery({
    queryKey: ['topUpDetails', topUpId],
    queryFn: () => getDetailsTopUps(topUpId),
  });
};

export const useGetConsumptions = (
  paginatedParams: IPaginatedParams,
  searchCriteria: ISearchCriteria,
) => {
  return useQuery({
    queryKey: ['consumptions', paginatedParams, searchCriteria],
    queryFn: () => getCreditsConsumption(paginatedParams, searchCriteria),
  });
};
